import { Button, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { generatePath, useNavigate, useParams } from "react-router";
import { useToast } from "../../../mantine/notifications/useToast";
import { ROUTES } from "../../../routes";
import { Paragraph6EEGCreditResponseTodo_alert_state } from "../../../types/api.types";

interface ShowParagraph6CreditsAlertsParams {
  todoAlertState?: Paragraph6EEGCreditResponseTodo_alert_state;
}

function useShowParagraph6CreditsAlerts() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const { projectId } = useParams<{ projectId: string }>();

  function showParagraph6CreditsAlerts({
    todoAlertState
  }: ShowParagraph6CreditsAlertsParams) {
    if (
      todoAlertState !==
      Paragraph6EEGCreditResponseTodo_alert_state.not_relevant
    ) {
      return;
    }

    const uniqueKey = `creditAlert${todoAlertState}`;
    const todosPath = projectId
      ? generatePath(ROUTES.todos.entry, { projectId })
      : undefined;

    showToast({
      id: uniqueKey,
      type: "warning",
      autoClose: false,
      withCloseButton: true,
      message: (
        <>
          Sie haben eine Änderung am Status Ihrer Gutschrift vorgenommen.
          Dadurch ist die bisherige Aufgabe zur Rückerstattung finanzieller
          Beteiligung hinfällig und wurde auf{" "}
          <Text fs="italic" span>
            Nicht relevant
          </Text>{" "}
          geändert.
          <br />
          Um auf die Aufgabe dennoch zugreifen zu können, filtern Sie bitte nach{" "}
          <Text fs="italic" span>
            Nicht relevant
          </Text>
          .
          {todosPath && (
            <Button
              mt="sm"
              variant="default"
              onClick={() => {
                navigate(todosPath);
                notifications.hide(uniqueKey);
              }}
            >
              Zu den Aufgaben
            </Button>
          )}
        </>
      )
    });
  }

  return { showParagraph6CreditsAlerts };
}

export { useShowParagraph6CreditsAlerts };
